import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

export const clearDeviceFeatures = () => {
  const map = mapAtom.map
  const layer = findLayer(map, 'device')

  layer.getSource()?.clear()
}
